import FetchService from "services/FetchService/CustomService";

const BaseUrl = process.env.BASE_URL;

const JobService = {
  async shareJob(jobId, page) {
    try {
      const url = BaseUrl + "/recruiter/job/v2/share-job";
      const response = await FetchService.postCall({
        url,
        body: {
          jobId,
          page: page || "dashboard"
        }
      });

      return response?.data?.data;
    } catch (error) {
      console.error("Error sharing job:", error);
      // We don't show toast here because the component will handle the error display
      throw error;
    }
  },

  async getJobList(params) {
    if (!params.tab) {
      throw new Error("Tab parameter is required for job-list service");
    }

    try {
      const url = BaseUrl + "/recruiter/job/job-list";
      const {
        tab,
        pageNumber,
        pageSize,
        selectedFilters = {},
        ...restParams
      } = params;

      const apiParams = {
        tab,
        ...(pageNumber && { page: pageNumber }),
        ...(pageSize && { size: pageSize }),
        ...restParams
      };

      Object.entries(selectedFilters).forEach(([key, values]) => {
        if (values && values.length > 0) {
          apiParams[key] = values.join(",");
        }
      });
      const response = await FetchService.getCall({
        url,
        query: apiParams,
        loaderConfig: { hasLoader: false }
      });

      // The API returns data in the format:
      // {
      //   jobs: [...],
      //   current_page: 1,
      //   total_pages: 1,
      //   total_jobs: 2,
      //   jobs_per_page: 10
      // }
      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching job list:", error);
      throw error;
    }
  },

  async getJobDetails(job_id) {
    if (!job_id) {
      throw new Error(
        "job_id parameter is required for get-job-details service"
      );
    }

    try {
      const url = BaseUrl + "/recruiter/job/get-job-details";

      const response = await FetchService.getCall({
        url,
        query: { job_id },
        loaderConfig: { hasLoader: false }
      });

      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching job details:", error);
      throw error;
    }
  },

  async stillHiring(jobId) {
    try {
      const url = BaseUrl + "/recruiter/job/still-hiring-nudge";
      const loaderConfig = { hasLoader: true };
      const response = await FetchService.postCall({
        url,
        body: {
          job_id: jobId
        },
        loaderConfig
      });

      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching still hiring:", error);
      throw error;
    }
  },

  async getDraftList(params = {}) {
    try {
      const url = BaseUrl + "/recruiter/job/get-draft-list";
      const { size = 10, ...restParams } = params;

      const apiParams = {
        size,
        ...restParams
      };

      const response = await FetchService.getCall({
        url,
        query: apiParams,
        loaderConfig: { hasLoader: false }
      });

      // Return the full response as it matches the expected format:
      // {
      //   status: true,
      //   data: [...],
      //   message: "",
      //   code: 200
      // }
      return response?.data;
    } catch (error) {
      console.error("Error fetching draft list:", error);
      throw error;
    }
  },

  async getDraftData(draftId) {
    if (!draftId) {
      throw new Error(
        "draftId parameter is required for get-draft-data service"
      );
    }
    try {
      const url = BaseUrl + "/recruiter/job/get-draft-data";

      const response = await FetchService.getCall({
        url,
        query: { draft_id: draftId },
        loaderConfig: { hasLoader: false }
      });

      return response?.data;
    } catch (error) {
      console.error("Error fetching draft data:", error);
      throw error;
    }
  },

  async getJobData(jobId) {
    if (!jobId) {
      throw new Error("jobId parameter is required for get-job-data service");
    }

    try {
      const url = BaseUrl + "/recruiter/job/get-job-data";
      const loaderConfig = { hasLoader: false };

      const response = await FetchService.postCall({
        url,
        body: {
          job_id: jobId
        },
        loaderConfig
      });

      return response?.data;
    } catch (error) {
      console.error("Error fetching job data:", error);
      throw error;
    }
  }
};

export default JobService;
